import { isObject, isStringEmpty } from '@shared/utils';
import appLogger from '@public/log/monitor';
import { fetchEventSource as msFetchEventSource } from '@microsoft/fetch-event-source';
import client from '@/store/client';
import navbarStore from '@/store/navbar';
import localRobot from '@/common/localRobot.js';
import apiRobot from './apiRobot';
import { HelperCore } from './dependencies';
import { request } from '.';
import chatStoreManager from '@/store/chat/manager';
import agentInstallStore from '@/pages/chat/components/agent-install/store'
import clientMcp from '@/store/clientMcp';
import Conf from './conf';

//意图识别
export const dentifyIntent = ({ question, category, aiso = 0 }) => {
  return request.get('/ai_agent/intent', {
    params: {
      question,
      category,
      aiso, // 默认0超级搜索, 1-表示普通ai搜索的入口
    },
  }).then(agentRes => {
     if(agentRes?.code == 0) {
      if(agentRes.data){//走超级搜索
        return {
          code: 0,
          agentId: agentRes.data.id,
          agentInfo: agentRes.data,
          agentType: agentRes.data.agent_type,
          role: agentRes.data.role_id || '',
          role_biz: 'ai_agent',
        }
      } else {//走AI搜索
        return {code: 1}
       }
     } else {
      //异常报错
      return {code: -1};
     }
   });
};

export function fetchEventSource(
  input,
  { body, onopen, onmessage, onclose, onerror, onhookBody = () => {}, ...reset }
) {
  let countOfRequests = 1;
  let last_event_id = 0;
  let conversationId = '';
  let messageId = '';
  const isLocalBot = client.isLLQ && navbarStore.chatModels[body.role]?.localModel;
  const isAPIBot = client.isLLQ && navbarStore.chatModels[body.role]?.chat_type === 100;

  const _onopen = res => {
    onopen?.(res, 'json')
  }

  const _onmessage = msg => {
    const { id, event, data } = msg;

    last_event_id = Number(id);

    const code = Number(event);
    if (!isStringEmpty(data)) {
      if (code == 100) {
        conversationId = data.replace('CONVERSATIONID####', '');
      } else if (code == 101) {
        messageId = data.replace('MESSAGEID####', '');
      }
    }

    if (countOfRequests != 1) {
      countOfRequests = 1;
    }

    onmessage?.(msg);
  }

  const create = async body => {
    if (isLocalBot) {
      return localRobot.fetch(body, {
        onopen: _onopen,
        onmessage: _onmessage,
        onclose,
        onerror,
      })
    }
    if (isAPIBot) {
      return apiRobot.fetch(body, {
        onopen: _onopen,
        onmessage: _onmessage,
        onclose,
        onerror,
      })
    }

    // 先生成 cid，以快速跳转对话页
    if(!body.conversation_id){
      try{
        const params = HelperCore.copyObj(body);
        if(params.kwargs && typeof params.kwargs != "string"){
          params.kwargs = JSON.stringify(params.kwargs);
        }
        // 该接口不需要 role 参数
        if (params.field_category) {
          params.role = '';
          params.from_aiso = 1;
          body.from_aiso = 1;
          delete body.field_category;
        }
        const resCid = await request.post("/assistant/new/conversation", {
          ...params,
          ...{
            title : params.prompt,
            field_category: ''
          },
        }, {
          dataIsJson : true,
        });
        const { conversation_id } = resCid.data;
        if(conversation_id){
          _onmessage({
            id: 0,
            event: 100,
            retry: "",
            data: `CONVERSATIONID####${conversation_id}`,
          });
          body.conversation_id = conversation_id;
          let intentRes = params.intentRes;
          let hasGenFileType = false;
          // AI 搜索首页，选择输出模式
          try{
            const kwargs = HelperCore.copyObj(body.kwargs);
            if(kwargs.specify_gen_file_type.length){
              hasGenFileType = true;
              body.ai_agent_id = Conf.agentIds.super;
              body.role_biz = "ai_agent";
              body.agent_type = 1;
              // 更新store相关字段为 agent 相关
              const chatStore = chatStoreManager.get(conversation_id);
              chatStore.setAiAgentId(body.ai_agent_id);
              chatStore.mcpStore.setAgentID(body.ai_agent_id);
            }
          } catch(e){}

          // AI 搜索首页，意图识别
          // 如果会话选择了智能体类型，则去服务端获取智能体id
          if (params.field_category && !body.ai_agent_id && !hasGenFileType) {
              if(!intentRes){
                intentRes = await dentifyIntent({
                  question: params.prompt,
                  category: params.field_category,
                });
              }

            if (intentRes?.code === 0) {
              const {agentId, agentInfo, agentType, role, role_biz} = intentRes;
              body.agent_type = agentType;
              body.ai_agent_id = agentId;
              body.role = role;
              body.role_biz = role_biz;
              // 更新store相关字段为 agent 相关
              const chatStore = chatStoreManager.get(conversation_id);
              chatStore.setAiAgentId(agentId);
              chatStore.mcpStore.setAgentID(agentId, agentInfo);
              // mcp 安装
              const mcp = await agentInstallStore.shouldInstall(agentId)
              // const mcp = await agentInstallStore.shouldInstall('aiagent007')
              if (mcp === 'notSupportMcpAgent') return
              body.mcp = mcp
            }
          }
        }
      } catch(e){}
    }

    // 安装 Mcp
    if(body.serverNames){
      const serverNames = body.serverNames;
      try{
        const mcp = await clientMcp.getMcpInfos(serverNames);
        if(mcp && Array.isArray(mcp)){
          body.mcp = mcp;
          if (mcp.length) {
            const role_biz = body.isAgentFlow ? "ai_agent_flow" : "ai_agent";
            body.role_biz = role_biz;
          }
        }
      } catch(e){}
      delete(body.serverNames);
      delete(body.isAgentFlow);
    }


    try{
      onhookBody(body);
    } catch(e){}
    return msFetchEventSource(input, {
      ...reset,
      body: JSON.stringify(body),
      onopen: res => onopen?.(res, 'stream'),
      onmessage: _onmessage,
      onclose: () => onclose?.(),
      onerror: err => {
        const shouldRetry = err?.name === 'TypeError';
        if (shouldRetry && countOfRequests <= 3) {
          window.setTimeout(() => {
            let retryBody = { retry: true };
            if (!isStringEmpty(messageId)) {
              retryBody = {
                ...retryBody,
                message_id: messageId,
                last_id: last_event_id,
              };
            }
            create({ ...body, ...retryBody });
            countOfRequests++;

            appLogger.log({
              key: 'aibot_plugin_public',
              action: 'message_fail',
              message_id: messageId,
              conversation_id: conversationId,
              role_id: isObject(body) ? body.role : '',
              ext1: 'sys_exception',
              ext2: 'retry',
              ext3: isObject(body) ? body.prompt : '',
            });
          }, countOfRequests * 1000);
        } else {
          onerror?.(err);
        }

        throw err;
      },
      ...(
        import.meta.env.VITE_LOCAL == 1
        ? { credentials : "include" }
        : {}
      ),
    });
  };

  return create(body);
}
